import { Constants } from "../../../contants";
import {
  INITIATE_VIEW_APPOINTMENT_DATA,
  SET_MEMBERS_FOR_APPLY_APPOINTMENT,
  SET_MEMBERS_FOR_APPLY_APPOINTMENT_FAIL,
  SET_MEMBER_FOR_APPLY_APPOINTMENT,
  SET_RESET_APPOINTMENT_STATE,
  SET_APPOINTMENT_FORM_STATE,
  SET_POSITION_ID,
  SET_SPLIT_SEARCH_RESULT,
  RESET_SPLIT_SEARCH_RESULT,
  SET_SPLIT_LEVEL,
  SET_MEMBERS_FOR_APPOINTMENT_TRACKING,
  SET_MEMBERS_FOR_APPOINTMENT_TRACKING_FAIL,
} from "../../actionTypes/dashboard";

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  error: null,
  applyAppointmentList: [],
  trackAppointmentList: [],
  selectedMemberId: null,
  selectedPositionId: null,
  formValues: { searchMember: "" },
  paginationInfo: {
    currentPage: 0,
    totalPages: 1,
    totalElements: 0,
    pageSize: Constants.DEFAULT_PAGE_SIZE,
  },
  blockChiefPaginationInfo: {
    currentPage: 0,
    totalPages: 1,
    totalElements: 0,
    pageSize: Constants.DEFAULT_PAGE_SIZE,
  },
  split: {
    searchResult: [],
    splitLevel: "DISTRICT",
    parentStructure: "AREA",
    nextChiefId: null,
    organisationStructure: {},
    parentStrutureName: "",
    parentStructureLevel: "",
  },
};

// eslint-disable-next-line default-param-last
const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case INITIATE_VIEW_APPOINTMENT_DATA:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case SET_MEMBERS_FOR_APPLY_APPOINTMENT:
      return {
        ...state,
        applyAppointmentList: payload.data,
        paginationInfo: payload?.paginationInfo ?? INITIAL_STATE.paginationInfo,
        blockChiefPaginationInfo:
          payload?.blockChiefPaginationInfo ??
          INITIAL_STATE.blockChiefPaginationInfo,
        isLoading: false,
      };
    case SET_MEMBERS_FOR_APPOINTMENT_TRACKING:
      return {
        ...state,
        trackAppointmentList: payload.data,
        paginationInfo: payload?.paginationInfo ?? INITIAL_STATE.paginationInfo,
        blockChiefPaginationInfo:
          payload?.blockChiefPaginationInfo ??
          INITIAL_STATE.blockChiefPaginationInfo,
        isLoading: false,
      };
    case SET_MEMBERS_FOR_APPOINTMENT_TRACKING_FAIL:
      return {
        ...state,
        trackAppointmentList: [],
        paginationInfo: INITIAL_STATE.paginationInfo,
        isLoading: false,
        error: payload,
      };
    case SET_MEMBERS_FOR_APPLY_APPOINTMENT_FAIL:
      return {
        ...state,
        applyAppointmentList: [],
        paginationInfo: INITIAL_STATE.paginationInfo,
        isLoading: false,
        error: payload,
      };
    case SET_MEMBER_FOR_APPLY_APPOINTMENT:
      return {
        ...state,
        selectedMemberId: payload,
      };
    case SET_RESET_APPOINTMENT_STATE:
      return {
        ...state,
        applyAppointmentList: [],
        selectedPositionId: null,
        isLoading: true,
      };
    case SET_APPOINTMENT_FORM_STATE:
      return {
        ...state,
        formValues: payload,
        isLoading: true,
      };
    case SET_POSITION_ID:
      return {
        ...state,
        selectedPositionId: payload,
      };
    case SET_SPLIT_SEARCH_RESULT:
      return {
        ...state,
        split: {
          ...state.split,
          searchResult: payload.data,
          splitLevel: payload.splitLevel,
          parentStructure: payload.parentStructure,
          organisationStructure: payload.selectedOS,
          parentStrutureName: payload.parentStrutureName,
          parentStructureLevel: payload.parentStructureLevel,
        },
        paginationInfo: payload?.paginationInfo ?? INITIAL_STATE.paginationInfo,
      };
    case RESET_SPLIT_SEARCH_RESULT:
      return {
        ...state,
        split: { ...state.split, searchResult: [] },
        paginationInfo: INITIAL_STATE.paginationInfo,
      };
    case SET_SPLIT_LEVEL:
      return {
        ...state,
        split: { ...state.split, splitLevel: payload },
      };

    default:
      return state;
  }
};

export default reducer;
